import { useQuery } from "@redux-requests/react";
import React, { useEffect } from "react";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { BaseLayout, Header, Loader } from "../components";
import PhysicalRoomsGrid from "../components/PhysicalRoomsGrid";
import { getPhysicalRooms } from "../ducks/actions";
import * as types from "../ducks/types";
import { ReactComponent as BadgeScanSvg } from "../assets/icons/badge scan.svg";

const PhysicalRoomsPage = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getPhysicalRooms());
  }, [dispatch]);
  const {
    data: { physical_rooms: physicalRooms },
    loading: physicalRoomsLoading
  } = useQuery({
    type: types.GET_PHYSICAL_ROOMS,
    defaultData: { physicalRooms: [] }
  });

  return (
    <BaseLayout>
      <Loader loading={physicalRoomsLoading}>
        <Header
          icon={BadgeScanSvg}
          title={intl.formatMessage({
            id: "Pages.PhysicalRoomsPage.BadgeScan",
            defaultMessage: "BadgeScan"
          })}
          helper={intl.formatMessage({
            id: "Pages.PhysicalRoomsPage.Description",
            defaultMessage:
              "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Rhoncus aenean vel elit scelerisque mauris pellentesque. Suspendisse interdum consectetur libero id faucibus nisl."
          })}
        />

        <PhysicalRoomsGrid rooms={physicalRooms} />
      </Loader>
    </BaseLayout>
  );
};

export default PhysicalRoomsPage;
